// import PropTypes from 'prop-types';
import React from 'react';
import {Warning} from "../../wui-core/src/index";
import Dropdown from './Dropdown';
import DropdownButton from "./DropdownButton";
import { DropdownIndexProps } from './iDropdown';

const {isShouldUpdate} = Warning;

const DropdownWrapper = (props: DropdownIndexProps) => {
    const {
        delayShow,
        mouseEnterDelay,
        delayHide,
        mouseLeaveDelay,
        ...others
    } = props;
    isShouldUpdate("Dropdown", props);
    const extral = {
        delayShow: mouseEnterDelay ?? delayShow,
        delayHide: mouseLeaveDelay ?? delayHide,
    }
    return (
        <Dropdown {...extral} {...others} />
    )
}

DropdownWrapper.Button = DropdownButton;
export default DropdownWrapper;
